module.exports = __webpack_public_path__ + "media/images/user/lp/step/ellipse3-7c710c8a2050c5358ba1eb35c0a2e953.png";